// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ArrowUpIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ArrowUp/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.293 9.707a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L11 5.414V17a1 1 0 0 1-2 0V5.414L4.707 9.707a1 1 0 0 1-1.414 0Z",
  clipRule: "evenodd"
}));
export default ArrowUpIcon;